export default __webpack_public_path__ + "static/media/about-us.a64fd05f.svg";